<template>
  <div class="fromStyle">
    <a-form :form="form" @submit="handleSubmit">
      <a-form-item label="用户" v-bind="formItemLayout">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-decorator="[
            'user_id',
            { rules: [{ required: true, message: '请选择用户!' }] }
          ]"
        >
          <a-select-option
            :value="element.id"
            v-for="(element, i) in userList"
            :key="i"
            >{{ element.user_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="身份" v-bind="formItemLayout">
        <a-radio-group v-model="identity">
          <a-radio :value="1">项目负责人</a-radio>
          <a-radio :value="2">区域管理员</a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="项目" v-bind="formItemLayout">
        <a-select
          showSearch
          :filterOption="filterOption"
          optionFilterProp="children"
          v-decorator="[
            'project_id',
            { rules: [{ required: true, message: '请选择项目!' }] }
          ]"
          @change="projectVal"
          placeholder="请选择项目"
        >
          <a-select-option
            v-for="(item, i) in proList"
            :key="i"
            :value="item.id"
            >{{ item.project_name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item
        v-show="identity == 2"
        label="管理区域"
        v-bind="formItemLayout"
      >
        <a-select
          style="width: 70%; margin-right: 10px"
          placeholder="请选择区域"
          mode="multiple"
          v-model="areaVal"
        >
          <a-select-option
            v-for="(item, i) in areaList"
            :key="i"
            :value="item.area"
            >{{ item.area }}</a-select-option
          >
        </a-select>
        <span>
          <a-checkbox @change="selectedAll">全选</a-checkbox>
        </span>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
        <a-button type="primary" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  inject: ["reload"],
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this),
      formItemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 12 }
      },
      identity: 1,
      userList: [],
      proList: [],
      areaList: [],
      areaVal: [],
      proArray: "multiple"
    };
  },
  watch: {
    identity() {
      this.identity == 1
        ? (this.proArray = "multiple")
        : (this.proArray = "default");
    }
  },
  mounted() {
    this.getUser(); //获取用户
    this.getPro(); //获取项目
  },
  methods: {
    selectedAll(e) {
      this.areaVal = [];
      if (e.target.checked) {
        this.areaList.forEach(element => {
          this.areaVal.push(element.area);
        });
      } else {
        this.areaVal = [];
      }
    },
    projectVal(value, option) {
      // console.log(value)
      this.getArea(value);
    },
    getArea(proID) {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.clean +
        "House/getHouseAreaByProjectId";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          project_id: proID
        })
        .then(res => {
          if (res.data.code == 200) {
            this.areaList = res.data.data;
            // console.log(this.areaList);
          }
        });
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getUser() {
      let url = this.httpsBasic.url + this.httpsBasic.user + "User/userList";
      let params = {
        token: window.localStorage.getItem("xnwfPcToken"),
        per_page: 10000,
        status: 0,
        role_type: 1
        // role_name_list: ["片区经理", "BOSS", "技术", "运营支持"]
      };
      axios.post(url, params).then(res => {
        if (res.data.code == 200) {
          this.userList = res.data.data.data;
          // console.log(this.userList);
        }
      });
    },
    getPro() {
      let url =
        this.httpsBasic.url +
        this.httpsBasic.trade +
        "Project/queryManagerProject";
      axios
        .post(url, {
          token: window.localStorage.getItem("xnwfPcToken"),
          trade_id: 3
        })
        .then(res => {
          if (res.data.code == 200) {
            this.proList = res.data.data;
            //  console.log(this.proList);
          }
        });
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, val) => {
        // console.log(val);
        if (!err) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.clean +
            "Clean_role/addInsideCleanRole";
          let params = {
            user_id: val.user_id,
            project_id: val.project_id,
            role_type: this.identity,
            project_area_id: JSON.stringify(this.areaVal),
            token: window.localStorage.getItem("xnwfPcToken")
          };
          // console.log(params);
          axios
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success("提交成功");
                this.$emit("hideInAdd", false);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch(err => {
              this.$message.error("服务器出错了...");
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.fromStyle {
  margin: 12% 4%;
}
</style>
